export const PAGE_SIZE = 20;